var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2.33317L3 0.666504L0.5 2.33317V14.8332C0.5 15.4962 0.763392 16.1321 1.23223 16.6009C1.70107 17.0698 2.33696 17.3332 3 17.3332H14.6667C15.3297 17.3332 15.9656 17.0698 16.4344 16.6009C16.9033 16.1321 17.1667 15.4962 17.1667 14.8332V12.3332H15.5V2.33317L13 0.666504L10.5 2.33317L8 0.666504L5.5 2.33317ZM13.8333 12.3332H3.83333V14.8332C3.83333 15.0542 3.74554 15.2661 3.58926 15.4224C3.43298 15.5787 3.22101 15.6665 3 15.6665C2.77899 15.6665 2.56702 15.5787 2.41074 15.4224C2.25446 15.2661 2.16667 15.0542 2.16667 14.8332V3.22484L3 2.66984L5.5 4.3365L8 2.66984L10.5 4.3365L13 2.66984L13.8333 3.22484V12.3332ZM14.6667 15.6665H5.35833C5.45 15.4057 5.5 15.1248 5.5 14.8332V13.9998H15.5V14.8332C15.5 15.0542 15.4122 15.2661 15.2559 15.4224C15.0996 15.5787 14.8877 15.6665 14.6667 15.6665Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.c88958b58d60631ff05df4915501b10f.svg";
export { ForwardRef as ReactComponent };